// Shared helpers for displaying a user's role and its organization scope.
// Mirrors the logic used inline in PageUsers.vue so the account page (and
// future callers) render roles consistently.
import { titleCase } from "@tod-ui/helpers/strings";

// The scope descriptor for an organization type — label, icon and color used
// to badge a role by where it applies.
export function roleScope(organization) {
  switch (organization?.type) {
    case "region":
      return {
        label: "Regional",
        icon: "mdi-selection-multiple-marker",
        color: "deep-purple",
      };
    case "facility":
      return { label: "Facility", icon: "mdi-domain", color: "teal" };
    case "organization":
      return {
        label: "Organization",
        icon: "mdi-sitemap",
        color: "indigo",
      };
    default:
      return {
        label: titleCase(organization?.type || "—"),
        icon: "mdi-office-building-outline",
        color: "grey",
      };
  }
}

// The role name prefixed with its scope level, e.g. "Facility Manager".
export function roleLabel(role, organization) {
  const name = titleCase(role?.name || "");
  const prefix = {
    region: "Regional",
    facility: "Facility",
    organization: "Organization",
  }[organization?.type];
  return prefix ? `${prefix} ${name}` : name;
}
